import React, { useEffect, useState, useCallback } from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import config from 'react-global-configuration';
import { View } from '@uncinc/react-drupal-core';

import { PageHeader } from '../../components';
import {
  HTTP_STATUS_PAGE_NOT_FOUND,
} from '../../config/constants';
import NotFound from '../NotFound';

const doTermQuery = (pillar) => {
  const API_URL = config.get('API_URL');

  return new Promise((resolve, reject) => {
    fetch(`${API_URL}/router/translate-path?path=/${pillar}&_format=json`)
      .then((response) => { return response.json(); })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const ViewPage = (props) => {
  const { className, pillar, contentType } = props;
  const [term, setTerm] = useState(Immutable.Map());
  const [didRequest, setDidRequest] = useState(false);
  const [filters, setFilters] = useState({});

  const list = {
    themas: {
      viewId: 'themes',
      title: 'Thema\'s',
    },
    artikelen: {
      viewId: 'articles',
      title: 'Artikelen',
    },
    nieuws: {
      viewId: 'news',
      title: 'Nieuws',
    },
    downloads: {
      viewId: 'downloads',
      title: 'Downloads',
    },
    opinies: {
      viewId: 'opinions',
      title: 'Opinie & Interview',
    },
  };

  const classes = classNames(className, 'Theme', 'TaxonomyTerm', 'TaxonomyTermThemeFull');

  const doTermSearch = useCallback(() => {
    doTermQuery(pillar)
      .then((response) => {
        const term = Immutable.fromJS(response);
        setTerm(term);
        setFilters({
          field_pillar_target_id: [term.getIn(['entity', 'entity', 'tid', 0, 'value'])],
        });
      });
  });

  useEffect(() => {
    if (!didRequest) {
      setDidRequest(true);
      doTermSearch();
    }
  }, [didRequest, doTermSearch]);

  if (!list[contentType]) {
    return (
      <NotFound status={HTTP_STATUS_PAGE_NOT_FOUND} />
    );
  }
  return (
    <article typeof="schema:WebPage" className={classes}>
      <PageHeader>
        <h1 className="PageHeader__title">{list[contentType].title}</h1>
        <div className="TaxonomyTermThemeFull__filters" />
      </PageHeader>
      <div className="TaxonomyTermThemeFull__contentWrapper" />
      {
        Object.keys(filters).length > 0 ? (
          <View id={list[contentType].viewId} display="pillar_all" filters={filters} />
        ) : null
      }
    </article>
  );
};

export default ViewPage;
